import { HStack, Skeleton, View,} from "native-base";
import React from "react";

const AreaKioskItemSkeleton = () => {
  return (
    <HStack
      h="55px"
      w="100%"
      rounded="md"
      borderWidth="1"
      padding="8px"
      borderColor="coolGray.100"
      space={6}
      justifyContent="space-between"
      alignItems="center"
      mb="10px"
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Skeleton
          h="27px"
          w="6px"
          rounded="lg"
          ml="7px"
          borderWidth={1}
          borderColor="coolGray.100"
        />
        <Skeleton
          h="3"
          w="100px"
          rounded="full"
          borderWidth={1}
          borderColor="coolGray.100"
        />
      </View>
      <Skeleton
        borderWidth={1}
        borderColor="coolGray.100"
        size="35px"
        rounded="md"
      />
    </HStack>
  );
};

export default AreaKioskItemSkeleton;
